import React from "react";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaGlobe,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import { SiX } from "react-icons/si";
import { Link } from "react-router-dom";

import DownloadAppleApp from "../assets/images-webp/downloadAppleApp.webp";
import DownloadAndroidApp from "../assets/images-webp/downloadAndroidApp.webp";

const Footer = () => {
  return (
    <div className="bg-[#0e2d3e] text-white py-10 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
        {/* Column 1 */}
        <div>
          <h4 className="text-xl font-bold mb-4">SwachhAJV</h4>
          <p className="mb-4">
            Empowering cities through smart waste solutions—efficient
            collection, real-time monitoring, and sustainable management for a
            cleaner tomorrow.
          </p>
          {/* <div className="flex -ml-2">
            <Link to="/shop">
              {" "}
              <img
                src={DownloadAppleApp}
                alt="App Store"
                className="w-32 object-contain"
              />
            </Link>
            <Link to="/shop">
              {" "}
              <img
                src={DownloadAndroidApp}
                alt="Play Store"
                className="w-32 object-contain"
              />{" "}
            </Link>
          </div> */}

          <div className="flex -ml-2">
            <Link to="/shop" state={{ category: "Mobile Application" }}>
              <img
                src={DownloadAppleApp}
                alt="App Store"
                className="w-32 object-contain"
              />
            </Link>
            <Link to="/shop" state={{ category: "Mobile Application" }}>
              <img
                src={DownloadAndroidApp}
                alt="Play Store"
                className="w-32 object-contain"
              />
            </Link>
          </div>
        </div>

        {/* Column 2 */}
        <div>
          <h4 className="text-xl font-bold mb-4">Products</h4>
          <ul className="space-y-2">
            <li>
              <Link to="/door-to-door-collection">Door-to-Door</Link>
            </li>
            <li>
              <Link to="/weighbridge">Weighbridge</Link>
            </li>
            <li>
              <Link to="/bin-monitoring">Bin Monitoring</Link>
            </li>
            <li>
              <Link to="/vehicle-monitoring">Vehicle Monitoring</Link>
            </li>
            <li>
              <Link to="/employee-management">Employee</Link>
            </li>
            <li>
              <Link to="/ai-waste-management">AI Waste</Link>
            </li>
          </ul>
        </div>

        {/* Column 3 */}
        <div>
          <h4 className="text-xl font-bold mb-4">Quick Links</h4>
          <ul className="space-y-2">
            <li>
              <Link to="/blogs">Blog</Link>
            </li>
            <li>
              <Link to="/videos">Video</Link>
            </li>
            <li>
              <Link to="/gallery">Gallery</Link>
            </li>
            <li>
              <Link to="/brochure">Brochure</Link>
            </li>
            <li>
              <Link to="/datasheet">DataSheet</Link>
            </li>
            <li>
              <Link to="/privacypolicy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/termofuse">Terms & Conditions</Link>
            </li>
          </ul>
        </div>

        {/* Column 4 */}
        <div>
          <h4 className="text-xl font-bold mb-4">Useful Links</h4>
          <ul className="space-y-2">
            <li>
              <a
                href="https://swachhbharatmission.ddws.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Swachh Bharat Mission
              </a>
            </li>
            <li>
              <a
                href="https://moef.gov.in/waste-management"
                target="_blank"
                rel="noopener noreferrer"
              >
                MOEF
              </a>
            </li>
            <li>
              <a
                href="https://www.india.gov.in/topics/environment-forest"
                target="_blank"
                rel="noopener noreferrer"
              >
                Environment & Forest
              </a>
            </li>
            <li>
              <a
                href="https://environment.delhi.gov.in/environment/waste-management"
                target="_blank"
                rel="noopener noreferrer"
              >
                Delhi Smart Waste
              </a>
            </li>
            <li>
              <a
                href="https://www.psa.gov.in/waste-to-wealth"
                target="_blank"
                rel="noopener noreferrer"
              >
                Waste to Wealth
              </a>
            </li>
          </ul>
        </div>

        {/* Column 5 */}
        <div>
          <h4 className="text-xl font-bold mb-4">Contact Info</h4>
          <div className="space-y-3">
            <p className="flex items-start gap-3">
              <FaMapMarkerAlt className="mt-1 text-[#00D084]" fontSize={30} />
              505, Tower A-1, Corporate Park, Noida-201301, Uttar Pradesh, India
            </p>
            <p className="flex items-center gap-3">
              <FaEnvelope className="text-[#00D084]" />
              presales@ajeevi.com
            </p>
            <p className="flex items-center gap-3">
              <FaPhoneAlt className="text-[#00D084]" />
              +91-9654323500
            </p>
            <p className="flex items-center gap-3">
              <FaGlobe className="text-[#00D084]" />
              <a
                href="https://ajeevi.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://ajeevi.com/
              </a>
            </p>
          </div>
          <div className="flex items-center gap-3 mt-4">
            <a
              href="https://www.facebook.com/ajeevidigitaal"
              className="bg-[#00D084] p-2 rounded-full"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://x.com/ajeevidigital"
              className="bg-[#00D084] p-2 rounded-full"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SiX />
            </a>
            <a
              href="https://www.instagram.com/ajeevidigital"
              className="bg-[#00D084] p-2 rounded-full"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href="https://in.linkedin.com/company/ajeevi-tech"
              className="bg-[#00D084] p-2 rounded-full"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </div>

      <div className="text-center mt-10 border-t border-white/10 pt-4 text-sm">
        <p>
          ©{" "}
          <a
            href="https://ajeevi.com/"
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ajeevi
          </a>
          , All right reserved. Designed by{" "}
          <a
            href="https://ajeevi.com/"
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ajeevi
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
